import React,{useState,useEffect} from 'react'
import Header from '../Components/Header';
import { Link } from "react-router-dom";
import axios from "axios";
import Image from '../Assets/print.gif'

const EstimateList = () => {
const [productName, setProductName] = useState('');
  const [productCode, setProductCode] = useState('');
  const [filteredProducts, setFilteredProducts] = useState([]);

  const [estimates, setEstimate] = useState([]);
  const [filteredEstimate, setFilteredEstimate] = useState([]);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [loading, setLoading] = useState(true); 
  const [currentPage, setCurrentPage] = useState(1);
  const [showModal, setShowModal] = useState(false);
  const recordsPerPage = 25;
  const totalRecords = filteredEstimate.length;
  const totalPages = Math.ceil(totalRecords / recordsPerPage);
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const [selectedestimateId, setSelectedEstimateId] = useState(null);

  // Calculate records for the current page
  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const currentRecords = filteredEstimate.slice(indexOfFirstRecord, indexOfLastRecord);

  // Function to change the page
  const paginate = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };

 const openDeleteModal = (estimate_id) =>{
    setSelectedEstimateId(estimate_id)
    setShowModal(true);
  }
  
  const closeModal = () => {
    setSelectedEstimateId(null);
    setShowModal(false);
};

  useEffect(() => {
    setLoading(true);
    axios.post(`${API_BASE_URL}estimate_list.php`)
      .then((response) => {
        if (response.data.head.code === 200 && Array.isArray(response.data.body)) {
          setEstimate(response.data.body);
          setFilteredEstimate(response.data.body);
        } else {
          console.error("Error Fetching Data:", response.data.head.msg);
          setEstimate([]);
          setFilteredEstimate([]);
        }
      })
      .catch((error) => {
        console.error("API Error:", error);
        setEstimate([]);
        setFilteredEstimate([]);
      }) .finally(() => {
        setLoading(false); // Set loading to false after API call
      });
  }, []);

  const convertDate = (dateString) => {
    if (!dateString || !dateString.includes("/")) return null; // Handle invalid formats
    const parts = dateString.split("/");
    if (parts.length !== 3) return null;
    return `${parts[2]}-${parts[1]}-${parts[0]}`; // Convert to YYYY-MM-DD
  };
  

  // ✅ Date Filter with Safe Date Handling
  const handleFilter = (e) => {
    e.preventDefault();

    if (!fromDate || !toDate) {
        console.error("Date fields are empty");
        return;
    }

    // Parse input dates (YYYY-MM-DD format from input fields)
    const startDate = new Date(fromDate);
    startDate.setHours(0, 0, 0, 0); // Ensure the entire day is included

    const endDate = new Date(toDate);
    endDate.setHours(23, 59, 59, 999); // Include full day

    if (isNaN(startDate.getTime()) || isNaN(endDate.getTime())) {
        console.error("Invalid date range");
        return;
    }

    // Filter estimate based on date range
    const filtered = estimates.filter((estimate) => {
        if (!estimate.estimatedate) return false; // Skip if estimate date is missing

        // Convert "DD-MM-YYYY" to a Date object
        const [day, month, year] = estimate.estimatedate.split("-").map(Number);
        const estimateDate = new Date(year, month - 1, day); // Months are zero-based

        // Normalize estimateDate to ignore time differences
        estimateDate.setHours(0, 0, 0, 0);

        return estimateDate >= startDate && estimateDate <= endDate;
    });

    setFilteredEstimate(filtered);
};

const handleDelete = async () => {
        if(!selectedestimateId) return;

        try {
          const response = await axios.post(`${API_BASE_URL}estimate_list_delete.php`,{
            estimate_id:selectedestimateId,
          });

          if(response.data.head.code === 200) {
            alert('estimate Deleted Successfully')
            closeModal();
            window.location.reload();

          } else{
            alert(response.data.head?.msg || "Failed to delete estimate");
          }
         
        }
        catch(error) {
          console.error("Error Deleting estimate", error)
          }

      };


  // ✅ Search Function with Safe Property Access
  const handleSearch = (e) => {
    const query = e.target.value;
    setSearchQuery(query);

    const searchedEstimate = estimates.filter((estimate) => {
      return (
        estimate.name?.toLowerCase().includes(query.toLowerCase()) ||
         estimate.agent?.toLowerCase().includes(query.toLowerCase()) ||
        estimate.billing_phonenumber?.includes(query) ||
        estimate.estimate_id?.includes(query)
      );
    });

    setFilteredEstimate(searchedEstimate);
    setCurrentPage(1);

  };
  localStorage.setItem('agentestimate', JSON.stringify(filteredEstimate));

  const totalAmount = currentRecords.reduce((sum, estimate) => {
    const amount = parseFloat(estimate.amount.replace(/,/g, "") || 0);
    return sum + amount;
  }, 0).toFixed(2);
    
  return (
    <>
    <Header/>
    <div class="page-wrapper compact-wrapper" id="pageWrapper">
        <div class="page-body-wrapper">
        <div className="page-body">
      <div className="container-fluid">
        <div className="row">
          <div className="col-sm-12">
            <div className="card card-table">
              <div className="card-body">
                <div className="title-header option-title d-sm-flex d-block">
                  <h5>List of Estimate</h5>
                  <div className="right-options">
                    <ul>
                      <li>
                        <Link className="btn btn-solid" to="/addestimate">
                          Add Estimate
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
                 {/* Search Box */}
                                       <div className="row">
                                         <div className="col-sm-6 col-md-6">
                                           <form className="theme-form theme-form-2 mega-form">
                                             <div className="mb-4 row align-items-center">
                                               <label htmlFor="search" className="col-sm-2 col-form-label">
                                                 Search:
                                               </label>
                                               <div className="col-sm-10">
                                                 <input
                                                   type="text"
                                                   id="search"
                                                   name="search"
                                                   className="form-control"
                                                   placeholder="Search Order"
                                                   value={searchQuery}
                                                   onChange={handleSearch}
                                                 />
                                               </div>
                                             </div>
                                           </form>
                                         </div>
                                         <div className='col-md-6 text-end'>
                                         <a 
                                      href={`/print_estimate_invoice`} 
                                      target="_blank" 
                                      rel="noopener noreferrer"
                                    >
                                      <img src={Image} alt="Print" border="0" />
                                    </a>
                                    </div>&nbsp;&nbsp;
                                       </div>
                 
                                       {/* Order Table */}
                                       {loading ? (
                         <div className="d-flex justify-content-center align-items-center" style={{ height: '200px' }}>
                           <div className="spinner-border text-primary" style={{ width: '3rem', height: '3rem' }} role="status">
                             <span className="visually-hidden">Loading...</span>
                           </div>
                         </div>
                       ) : (
                         <>
                                       <div className="table-responsive">
                                         <table className="table all-package theme-table table-product">
                                           <thead>
                                             <tr>
                                               <th>Estimate ID</th>
                                               <th>Date</th>
                                                <th>Agent</th>
                                               <th>Customer Name</th>
                                               <th style={{textAlign:"center"}}>Mobile</th>
                                               <th style={{textAlign:"right"}}>Amount</th>
                                               <th style={{textAlign:"right"}}>Status</th>
                                               {/* <th style={{textAlign:"center"}}>Payment Status</th> */}
                                               <th>View</th>
                                               <th>Action</th>
                                             </tr>
                                           </thead>
                                           <tbody>
                                             {currentRecords.length > 0 ? (
                                               currentRecords.map((estimate) => (
                                                 <tr key={estimate.estimate_id}>
                                                   <td>{estimate.estimate_id}</td>
                                                   <td>{estimate.estimatedate || "N/A"}</td>
                                                   <td>{estimate.agent || "N/A"}</td>
                                                   <td>{estimate.name || "N/A"}</td>
                                                   <td style={{textAlign:"center"}} >{estimate.billing_phonenumber || "N/A"}</td>
                                                   <td style={{textAlign:"right"}}>
                                                     <i className="fas fa-rupee-sign"></i> {parseFloat(estimate.amount.replace(/,/g, "") || 0).toFixed(2)}
                                                   </td>
                                                   <td style={{ color: estimate.status === "Paid" ? "green" : "red" }}>{estimate.status || "N/A"}</td>
                                                   <td>
                                                     <Link to={`/estimatedetails/${estimate.estimate_id}`}>
                                                       <i className="ri-eye-line"></i>
                                                     </Link>
                                                   </td>
                                                   <td>
                                                    <ul>
                                                      <li >
                                                        <Link
                                                          to={estimate.status === "Paid" ?"":`/editestimate/${estimate.estimate_id}`}
                                                        >
                                                          <i style={{cursor: estimate.status === "Paid" ? "not-allowed" :"pointer" }} className="ri-pencil-line"></i>
                                                        </Link>
                                                      </li>
                                                      
                                                      <li>
                                                        <a href="#" onClick={(e) => { e.preventDefault(); openDeleteModal(estimate.estimate_id); }}>
                                                          <i  className="ri-delete-bin-line"></i>
                                                        </a>
                                                      </li>
                                                    </ul>
                                                   </td>
                                                 </tr>
                                               ))
                                             ) : (
                                               <tr>
                                                 <td colSpan="5" className="text-center">
                                                   No estimate found
                                                 </td>
                                               </tr>
                                             )}
                                            <tr id="total">
                                             <td colSpan="5">
                                               <h3>Total:</h3>
                                             </td>
                                             <td style={{ textAlign: "right" }}>
                                               <h3>
                                                 <i className="fas fa-rupee-sign"></i> {totalAmount}
                                               </h3>
                                             </td>
                                             <td></td>
                                           </tr>
                 
                                   <td colSpan="9">
                                   <table width="100%" border="1" style={{ borderCollapse: "collapse", border: "1px solid #000" }}>
                                     <tr>
                                       <td width="20%">Page {currentPage} of {totalPages}</td>
                                       <td style={{ textAlign: "right" }}>
                                         {/* Previous Button */}
                                         {currentPage > 1 ? (
                                           <a className="pagetext" href="javascript:void(0);" onClick={() => paginate(currentPage - 1)}>
                                             &laquo; Previous
                                           </a>
                                         ) : (
                                           <span>&laquo; Previous</span>
                                         )}
                                         &nbsp;
                                         {/* Page Numbers */}
                                         {[...Array(totalPages)].map((_, i) => (
                                            <React.Fragment key={i}>
                                           <a
                                             key={i}
                                             className={`pagetext ${currentPage === i + 1 ? "active" : ""}`}
                                             href="javascript:void(0);"
                                             onClick={() => paginate(i + 1)}
                                           >
                                             {i + 1}
                                           </a>
                                           &nbsp;
                                           </React.Fragment>
                                         ))}
                 
                                         {/* Next Button */}
                                         {currentPage < totalPages ? (
                                           <a className="pagetext" href="javascript:void(0);" onClick={() => paginate(currentPage + 1)}>
                                             Next &raquo;
                                           </a>
                                         ) : (
                                           <span>Next &raquo;</span>
                                         )}
                 
                                         {/* Last Button */}
                                         {currentPage < totalPages ? (
                                           <a className="pagetext" href="javascript:void(0);" onClick={() => paginate(totalPages)}>
                                             Last &raquo;&raquo;
                                           </a>
                                         ) : (
                                           <span>Last &raquo;&raquo;</span>
                                         )}
                                       </td>
                                     </tr>
                                   </table>
                                 </td>
                                 
                                           </tbody>
                                         </table>
                                       </div>
                                       </>
                                       )}
                                     </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

        
     </div>
     {showModal && (
                <div className="modal fade show" style={{ display: "block" }}>
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-body">
                                <h5>Confirm Delete</h5>
                                <p>Are you sure you want to delete this estimate?</p>
                                <button type="button" className="btn-close" onClick={closeModal}></button>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={closeModal}>
                                    No
                                </button>
                                <button type="button" className="btn btn-danger" onClick={handleDelete}>
                                    Yes, Delete
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

    </>
  )
}

export default EstimateList